import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Enforce canonical URLs: no trailing slash (except "/").
    // Combined with the beforeLoad redirect in __root.tsx this yields
    // a 301 to the canonical form during SSR.
    trailingSlash: "never",
  });

  return router;
};
